import { render, staticRenderFns } from "./DiseaseAlertList.vue?vue&type=template&id=956c2736&scoped=true&"
import script from "./DiseaseAlertList.vue?vue&type=script&lang=js&"
export * from "./DiseaseAlertList.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseAlertList.vue?vue&type=style&index=0&id=956c2736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956c2736",
  null
  
)

export default component.exports